"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiEmailFormatter = void 0;
const aiEmailFormatter = (orgIdName, itineraryId, sectionId, itineraryCode) => {
    const emailLinkStart = 'eventr-bookings+';
    const emailLinkEnd = '@softpauer.com';
    const fullEmailLink = emailLinkStart +
        (process.env.REACT_APP_ENV === 'demo'
            ? ''
            : process.env.REACT_APP_ENV + '-') +
        orgIdName +
        '-' +
        itineraryId +
        '-' +
        sectionId +
        '-' +
        itineraryCode +
        emailLinkEnd;
    return fullEmailLink;
};
exports.aiEmailFormatter = aiEmailFormatter;
